import React, { useState } from "react";
import { Loader2, MessageSquare, ThumbsUp } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// 公开周报页 · 业主点赞 + 一行评论（提交后可修改一次）
export const WeeklyFeedback = ({ share, feedback, T, onSaved }) => {
  const [like, setLike] = useState(feedback?.like ?? null);
  const [comment, setComment] = useState(feedback?.comment || "");
  const [editing, setEditing] = useState(!feedback);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async () => {
    if (like === null && !comment.trim()) { setErr(T("请点赞或留下一句评论", "Tap 👍 or leave a comment")); return; }
    setBusy(true); setErr("");
    try {
      const r = await fetch(`${BACKEND}/api/public/weekly/${share}/feedback`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ like, comment: comment.trim() }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Failed");
      onSaved && onSaved(d.feedback);
      setEditing(false);
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };
  return (
    <div className="mt-4 rounded-2xl bg-slate-900 border border-slate-800 p-4" data-testid="wk-feedback" data-state={editing ? "editing" : "saved"}>
      <p className="text-xs font-bold text-slate-300 mb-2 flex items-center gap-1.5"><MessageSquare className="h-3.5 w-3.5 text-red-400" />{T("给项目经理一点反馈", "Feedback for your PM")}</p>
      {!editing && feedback ? (
        <div className="flex items-start gap-3">
          <div className="flex-1 text-[13px] text-slate-200">
            {feedback.like && <span data-testid="wk-feedback-liked" className="inline-flex items-center gap-1 text-emerald-400 font-semibold mr-2"><ThumbsUp className="h-4 w-4" />{T("已点赞", "Liked")}</span>}
            {feedback.comment && <span data-testid="wk-feedback-comment-text" className="text-slate-300">「{feedback.comment}」</span>}
            <p className="text-[10px] text-slate-500 mt-1">{T("已发送给项目经理，感谢您的反馈", "Sent to your PM — thank you")}{feedback.canEdit ? T(" · 可修改一次", " · you may edit once") : ""}</p>
          </div>
          {feedback.canEdit && <button data-testid="wk-feedback-edit" onClick={() => setEditing(true)} className="text-[11px] px-2.5 py-1 rounded-full border border-slate-700 text-slate-300">{T("修改", "Edit")}</button>}
        </div>
      ) : (
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <button data-testid="wk-feedback-like" data-active={like === true} onClick={() => setLike(like === true ? null : true)}
              className={`h-10 px-4 rounded-xl inline-flex items-center gap-1.5 text-sm font-semibold transition-colors ${like === true ? "bg-emerald-600 text-white" : "bg-slate-800 text-slate-200 active:bg-slate-700"}`}>
              <ThumbsUp className={`h-4 w-4 ${like === true ? "fill-current" : ""}`} />{T("本周做得不错", "Nice work this week")}
            </button>
          </div>
          <input data-testid="wk-feedback-comment" value={comment} maxLength={140} onChange={(e) => setComment(e.target.value)} placeholder={T("一句话评论（可选）", "One-line comment (optional)")}
            className="w-full h-10 rounded-xl bg-slate-800 border border-slate-700 px-3 text-sm text-slate-100 placeholder:text-slate-500 outline-none focus:border-brand-500" />
          {err && <p data-testid="wk-feedback-error" className="text-[11px] text-red-400">{err}</p>}
          <div className="flex gap-2">
            <button data-testid="wk-feedback-submit" disabled={busy} onClick={submit} className="flex-1 h-10 rounded-xl bg-brand-500 text-white text-sm font-bold inline-flex items-center justify-center gap-1.5 active:bg-brand-600 disabled:opacity-60">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}{T("发送给项目经理", "Send to PM")}</button>
            {feedback && <button data-testid="wk-feedback-cancel" onClick={() => { setEditing(false); setLike(feedback.like ?? null); setComment(feedback.comment || ""); }} className="h-10 px-3 rounded-xl border border-slate-700 text-sm text-slate-300">{T("取消", "Cancel")}</button>}
          </div>
        </div>
      )}
    </div>
  );
};
